export const BASE_URL = process.env.REACT_APP_API_URL;

export const REGISTER_ERROR_CODE = { 1: "signup.email_is_taken" };
export const PASSWORD_RESET_ERROR_CODE = {
  1: "signup.invalid_or_expired_token",
  2: "Token is valid, but password not provided",
  3: "signup.password_reset_err.current_password_not_correct",
  4: "signup.password_reset_err.new_password_same_to_current",
};
